import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
import { exportToExcel } from '../../lib/xlsx/xlsxLibrary';
import { getMainWeight, getCladdingWeight } from './editor-components/weightSummary';

const TowerListActionButtons = () => {
    const project = useSelector(state => state.project.project);
    const towers = useSelector(state => state.towers.towers);
    const user = useSelector(state => state.user.user);

    if (!towers) return;

    const ownProject = (user && user._id) === (project && project.user._id);

    /* Excel Export를 위해 towers Data를 가공해야 한다. <- 안할 수는 없나??? */
    const exportData = dataConvert(towers);
    const projectName = project?.title;

    return (
        <TowerListActionButtonsBlock>
            {ownProject && (
                <>
                    <StyledLink to="/write/tower">
                        Add Tower
                        <MdAdd />
                    </StyledLink>
                    <StyledButton onClick={() => exportToExcel(exportData, projectName)}>
                        Download Excel File(.xlsx)
                    </StyledButton>
                </>
            )}
        </TowerListActionButtonsBlock>
    );
};

export default TowerListActionButtons;

/* =================   Styles   ================== */

const TowerListActionButtonsBlock = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
`;

const StyledLink = styled(Link)`
    padding: 0.25rem 1rem 0.35rem;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        transition: 0.3s;
    }
`;

const StyledButton = styled.button`
    padding: 0.25rem 1rem 0.35rem;
    border: 1px solid transparent;
    border-radius: 2px;
    background-color: ${palette.gray[6]};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.gray[6]};
        border: 1px solid ${palette.gray[6]};
        transition: 0.3s;
        cursor: pointer;
    }
`;

/* =================   Excel Export   ================== */
const dataConvert = (towers) => {
    let data = [];
    towers.map((tower) => data.push(rowGenerator(tower)));
    return data;
};

const rowGenerator = (tower) => {
    if (!tower.body) return;
    const { size, floors, cladding, weightSummary, etc, userInput, grandTotal } = tower.body;

    return {
        'Tower\nID': `${tower.title || ''}`,
        'Width': `${size.main?.width || ''}`,
        'Length': `${size.main?.length || ''}`,
        'Height': `${size.main?.height || ''}`,
        'Volume': `${size.main?.volume || ''}`,
        'qtyDrive': `${floors.driveFloor?.qty || ''}`,
        'qtyNon-Drive': `${floors.nonDriveFloor?.qty || ''}`,
        'qtyAccess': `${floors.accessFloor?.qty || ''}`,
        'areaDrive': `${floors.driveFloor.totalAreaFloor || ''}`,
        'areaNon-Drive': `${floors.nonDriveFloor.totalAreaFloor || ''}`,
        'areaAccess': `${floors.accessFloor.totalAreaFloor || ''}`,
        'Roofing': `${cladding.roofing.area || ''}`,
        'Siding': `${cladding.siding.area || ''}`,
        'Structure': `${getMainWeight(weightSummary) || ''}`,
        'Cladding': `${getCladdingWeight(weightSummary) || ''}`,
        'Etc.': `${etc?.etcWeight || ''}`,
        'H.T.Bolt/Nut': `${etc?.fastenerWeight || ''}`,
        'Anchor Bolt': `${etc?.anchorWeight || ''}`,
        'User Input': `${userInput?.weight || ''}`,
        'Total': `${grandTotal || ''}`,
    };
};


